const form_9141 = {
  name: "Form ETA-9141",
  label: "Prevailing Wage Determination",
  form_type: "9141",
  available_date: "2019-06-10T04:00:00Z", // available June 10
  simpleForm: true,
  reuse: true,
};

export default [
  {
    name: "H-2B",
    description: "Temporary Labor Certification for Non-agricultural Workers",
    link: "https://flag.dol.gov/programs/H-2B",
    forms: [
      form_9141,
      {
        name: "Form ETA-9142B",
        label: "Temporary Labor Certification",
        form_type: "9142B",
        simpleForm: true,
        available_date: "2019-06-13T22:00:00Z", // available June 13, 10am ET
      },
    ],
  },
  {
    name: "H-2A",
    description: "Temporary Labor Certification for Agricultural Workers",
    link: "https://flag.dol.gov/programs/H-2A",
    forms: [
      {
        name: "Form ETA-790/790A",
        label: "Agricultural Clearance Order",
        form_type: "790A",
        available_date: "2019-06-10T22:00:00Z", // available June 13, 10am ET
        simpleForm: true,
        reuse: true,
      },
      {
        name: "Form ETA-9142A",
        label: "Temporary Labor Certification",
        form_type: "9142A",
        available_date: "2019-06-10T22:00:00Z", // available June 13, 10am ET
        simpleForm: true,
      },
    ],
  },
  {
    name: "H-1B | H-1B1 | E-3",
    description: "Labor Condition Application (LCA) for Specialty Occupations",
    link: "https://flag.dol.gov/programs/LCA",
    forms: [
      form_9141,
      {
        name: "Form ETA-9035/9035E",
        label: "Labor Condition for Nonimmigrant Workers",
        form_type: "9035",
        available_date: "2019-06-10T22:00:00Z", // available June 13, 10am ET
        simpleForm: true,
        reuse: true,
      },
    ],
  },
  {
    name: "CW-1",
    description:
      "Transitional Worker Program in the Commonwealth of the Northern Mariana Islands",
    link: "https://flag.dol.gov/programs/cw1",
    forms: [
      {
        name: "Form ETA-9141C",
        form_type: "9141C",
        label: "Prevailing Wage Determination",
        available_date: "2019-04-01T18:00:00Z", // available April 1, 2pm ET
        simpleForm: true,
      },
      {
        name: "Form ETA-9142C",
        label: "Temporary Labor Certification",
        form_type: "9142C",
        available_date: "2019-04-01T18:00:00Z", // available April 1, 2pm ET
        simpleForm: true,
      },
    ],
  },
  {
    name: "PERM",
    description: "Permanent Employment Certification for Workers",
    link: "https://flag.dol.gov/programs/perm",
    forms: [
      form_9141,
      {
        name: "Form ETA-9089",
        label: "Permanent Employment Certification",
        form_type: "9089", //TODO: Change to PERM Form.
        available_date: "2022-10-10T22:00:00Z", //Don't think this matters
        simpleForm: true,
        //reuse for PERM set in FormButton.js with env variables in lower environments, to currently only allow reuse for devs and testers
      },
    ],
  },
];
